!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define("lib", ["react", "react-dom"], t) : "object" == typeof exports ? exports.lib = t(require("react"), require("react-dom")) : e.lib = t(e.react, e["react-dom"]);
}("undefined" != typeof self ? self : this, function (n, r) {
  return a = {}, o.m = i = [function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useReactToPrint = t.PrintContextConsumer = void 0;
    var r = n(1),
        i = n(2),
        a = n(3),
        o = i.hasOwnProperty("createContext"),
        l = i.hasOwnProperty("useMemo") && i.hasOwnProperty("useCallback"),
        u = o ? i.createContext({}) : null;
    t.PrintContextConsumer = u ? u.Consumer : function () {
      return null;
    };
    var c,
        s = {
      copyStyles: !0,
      pageStyle: "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",
      removeAfterPrint: !1,
      suppressErrors: !1
    },
        f = (c = i.Component, r.__extends(d, c), d.prototype.render = function () {
      var e = this.props,
          t = e.children,
          n = e.suppressErrors,
          r = e.trigger;
      if (r) return i.cloneElement(r(), {
        onClick: this.handleClick
      });
      var o = {
        handlePrint: this.handleClick
      };
      return u ? u ? i.createElement(u.Provider, {
        value: o
      }, t) : i.createElement("h2", null, "lorem") : (n || console.error('"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'), null);
    }, d.defaultProps = s, d);

    function d() {
      var E = null !== c && c.apply(this, arguments) || this;
      return E.startPrint = function (t) {
        var e = E.props,
            n = e.onAfterPrint,
            r = e.onPrintError,
            o = e.print,
            i = e.suppressErrors,
            a = e.documentTitle;
        setTimeout(function () {
          if (t.contentWindow) {
            if (t.contentWindow.focus(), o) o(t).then(E.handleRemoveIframe).catch(function (e) {
              r ? r("print", e) : i || console.error("An error was thrown by the specified `print` function", e);
            });else if (t.contentWindow.print) {
              var e = document.title;
              a && (document.title = a), t.contentWindow.print(), a && (document.title = e), n && n();
            } else i || console.error("Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes.");
            E.handleRemoveIframe();
          } else i || console.error("Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/");
        }, 500);
      }, E.triggerPrint = function (e) {
        var t = E.props,
            n = t.onBeforePrint,
            r = t.onPrintError;

        if (n) {
          var o = n();
          o && "function" == typeof o.then ? o.then(function () {
            E.startPrint(e);
          }).catch(function (e) {
            r && r("onBeforePrint", e);
          }) : E.startPrint(e);
        } else E.startPrint(e);
      }, E.handleClick = function () {
        var e = E.props,
            t = e.onBeforeGetContent,
            n = e.onPrintError;

        if (t) {
          var r = t();
          r && "function" == typeof r.then ? r.then(E.handlePrint).catch(function (e) {
            n && n("onBeforeGetContent", e);
          }) : E.handlePrint();
        } else E.handlePrint();
      }, E.handlePrint = function () {
        var e = E.props,
            P = e.bodyClass,
            t = e.content,
            x = e.copyStyles,
            O = e.pageStyle,
            S = e.suppressErrors,
            n = t();
        if (void 0 !== n) {
          if (null !== n) {
            var k = document.createElement("iframe");
            k.style.position = "absolute", k.style.top = "-1000px", k.style.left = "-1000px", k.id = "printWindow", k.title = "Print Window";
            var j = a.findDOMNode(n);

            if (j) {
              var r = document.querySelectorAll("link[rel='stylesheet']"),
                  C = j.querySelectorAll("img");
              E.linkTotal = r.length + C.length, E.linksLoaded = [], E.linksErrored = [];

              var T = function T(e, t) {
                t ? E.linksLoaded.push(e) : (S || console.error('"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:', e), E.linksErrored.push(e)), E.linksLoaded.length + E.linksErrored.length === E.linkTotal && E.triggerPrint(k);
              };

              k.onload = function () {
                var e;
                k.onload = null;
                var t = k.contentDocument || (null === (e = k.contentWindow) || void 0 === e ? void 0 : e.document),
                    n = j.querySelectorAll("canvas");

                if (t) {
                  t.open(), t.write(j.outerHTML), t.close();
                  var r = "function" == typeof O ? O() : O,
                      o = t.createElement("style");
                  o.appendChild(t.createTextNode(r)), t.head.appendChild(o), P && t.body.classList.add(P);

                  for (var i = t.querySelectorAll("canvas"), a = 0, l = i.length; a < l; ++a) {
                    var u = (h = i[a]).getContext("2d");
                    u && u.drawImage(n[a], 0, 0);
                  }

                  for (a = 0; a < C.length; a++) {
                    var c = C[a],
                        s = c.getAttribute("src");

                    if (s) {
                      var f = new Image();
                      f.onload = T.bind(null, c, !0), f.onerror = T.bind(null, c, !1), f.src = s;
                    } else S || console.warn('"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:', c);
                  }

                  if (x) for (var d = document.querySelectorAll("style, link[rel='stylesheet']"), p = (a = 0, d.length); a < p; ++a) {
                    var h;

                    if ("STYLE" === (h = d[a]).tagName) {
                      var y = t.createElement(h.tagName),
                          b = h.sheet;

                      if (b) {
                        for (var m = "", v = 0, w = b.cssRules.length; v < w; ++v) {
                          "string" == typeof b.cssRules[v].cssText && (m += b.cssRules[v].cssText + "\r\n");
                        }

                        y.setAttribute("id", "react-to-print-" + a), y.appendChild(t.createTextNode(m)), t.head.appendChild(y);
                      }
                    } else if (h.getAttribute("href")) {
                      y = t.createElement(h.tagName), v = 0;

                      for (var g = h.attributes.length; v < g; ++v) {
                        var _ = h.attributes[v];
                        _ && y.setAttribute(_.nodeName, _.nodeValue || "");
                      }

                      y.onload = T.bind(null, y, !0), y.onerror = T.bind(null, y, !1), t.head.appendChild(y);
                    } else S || console.warn('"react-to-print" encountered a <link> tag with an empty "href" attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:', h), T(h, !0);
                  }
                }

                0 !== E.linkTotal && x || E.triggerPrint(k);
              };

              var o = document.getElementById("printWindow");
              o && document.body.removeChild(o), document.body.appendChild(k);
            } else S || console.error('"react-to-print" could not locate the DOM node corresponding with the `content` prop');
          } else S || console.error('There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.');
        } else S || console.error('For "react-to-print" to work only Class based components can be printed.');
      }, E.handleRemoveIframe = function () {
        if (E.props.removeAfterPrint) {
          var e = document.getElementById("printWindow");
          e && document.body.removeChild(e);
        }
      }, E;
    }

    t.default = f, t.useReactToPrint = l ? function (e) {
      var t = i.useMemo(function () {
        return new f(r.__assign(r.__assign({}, s), e));
      }, [e]);
      return i.useCallback(function () {
        return t.handleClick();
      }, [t]);
    } : function (e) {
      e.suppressErrors || console.warn('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "__extends", function () {
      return o;
    }), n.d(t, "__assign", function () {
      return _i;
    }), n.d(t, "__rest", function () {
      return a;
    }), n.d(t, "__decorate", function () {
      return l;
    }), n.d(t, "__param", function () {
      return u;
    }), n.d(t, "__metadata", function () {
      return c;
    }), n.d(t, "__awaiter", function () {
      return s;
    }), n.d(t, "__generator", function () {
      return f;
    }), n.d(t, "__exportStar", function () {
      return d;
    }), n.d(t, "__values", function () {
      return p;
    }), n.d(t, "__read", function () {
      return h;
    }), n.d(t, "__spread", function () {
      return y;
    }), n.d(t, "__spreadArrays", function () {
      return b;
    }), n.d(t, "__await", function () {
      return m;
    }), n.d(t, "__asyncGenerator", function () {
      return v;
    }), n.d(t, "__asyncDelegator", function () {
      return w;
    }), n.d(t, "__asyncValues", function () {
      return g;
    }), n.d(t, "__makeTemplateObject", function () {
      return _;
    }), n.d(t, "__importStar", function () {
      return P;
    }), n.d(t, "__importDefault", function () {
      return x;
    }), n.d(t, "__classPrivateFieldGet", function () {
      return O;
    }), n.d(t, "__classPrivateFieldSet", function () {
      return S;
    });

    var _r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    };

    function o(e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }

    var _i = function i() {
      return (_i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    function a(e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    }

    function l(e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; 0 <= l; l--) {
        (o = e[l]) && (a = (i < 3 ? o(a) : 3 < i ? o(t, n, a) : o(t, n)) || a);
      }
      return 3 < i && a && Object.defineProperty(t, n, a), a;
    }

    function u(n, r) {
      return function (e, t) {
        r(e, t, n);
      };
    }

    function c(e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    }

    function s(e, a, l, u) {
      return new (l = l || Promise)(function (n, t) {
        function r(e) {
          try {
            i(u.next(e));
          } catch (e) {
            t(e);
          }
        }

        function o(e) {
          try {
            i(u.throw(e));
          } catch (e) {
            t(e);
          }
        }

        function i(e) {
          var t;
          e.done ? n(e.value) : ((t = e.value) instanceof l ? t : new l(function (e) {
            e(t);
          })).then(r, o);
        }

        i((u = u.apply(e, a || [])).next());
      });
    }

    function f(n, r) {
      var o,
          i,
          a,
          e,
          l = {
        label: 0,
        sent: function sent() {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: []
      };
      return e = {
        next: t(0),
        throw: t(1),
        return: t(2)
      }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
        return this;
      }), e;

      function t(t) {
        return function (e) {
          return function (t) {
            if (o) throw new TypeError("Generator is already executing.");

            for (; l;) {
              try {
                if (o = 1, i && (a = 2 & t[0] ? i.return : t[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, t[1])).done) return a;

                switch (i = 0, a && (t = [2 & t[0], a.value]), t[0]) {
                  case 0:
                  case 1:
                    a = t;
                    break;

                  case 4:
                    return l.label++, {
                      value: t[1],
                      done: !1
                    };

                  case 5:
                    l.label++, i = t[1], t = [0];
                    continue;

                  case 7:
                    t = l.ops.pop(), l.trys.pop();
                    continue;

                  default:
                    if (!(a = 0 < (a = l.trys).length && a[a.length - 1]) && (6 === t[0] || 2 === t[0])) {
                      l = 0;
                      continue;
                    }

                    if (3 === t[0] && (!a || t[1] > a[0] && t[1] < a[3])) {
                      l.label = t[1];
                      break;
                    }

                    if (6 === t[0] && l.label < a[1]) {
                      l.label = a[1], a = t;
                      break;
                    }

                    if (a && l.label < a[2]) {
                      l.label = a[2], l.ops.push(t);
                      break;
                    }

                    a[2] && l.ops.pop(), l.trys.pop();
                    continue;
                }

                t = r.call(n, l);
              } catch (e) {
                t = [6, e], i = 0;
              } finally {
                o = a = 0;
              }
            }

            if (5 & t[0]) throw t[1];
            return {
              value: t[0] ? t[1] : void 0,
              done: !0
            };
          }([t, e]);
        };
      }
    }

    function d(e, t) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    function p(e) {
      var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
      if (n) return n.call(e);
      if (e && "number" == typeof e.length) return {
        next: function next() {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
      throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function h(e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          o,
          i = n.call(e),
          a = [];

      try {
        for (; (void 0 === t || 0 < t--) && !(r = i.next()).done;) {
          a.push(r.value);
        }
      } catch (e) {
        o = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (o) throw o.error;
        }
      }

      return a;
    }

    function y() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(h(arguments[t]));
      }

      return e;
    }

    function b() {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    }

    function m(e) {
      return this instanceof m ? (this.v = e, this) : new m(e);
    }

    function v(e, t, n) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var o,
          i = n.apply(e, t || []),
          a = [];
      return o = {}, r("next"), r("throw"), r("return"), o[Symbol.asyncIterator] = function () {
        return this;
      }, o;

      function r(r) {
        i[r] && (o[r] = function (n) {
          return new Promise(function (e, t) {
            1 < a.push([r, n, e, t]) || l(r, n);
          });
        });
      }

      function l(e, t) {
        try {
          (n = i[e](t)).value instanceof m ? Promise.resolve(n.value.v).then(u, c) : s(a[0][2], n);
        } catch (e) {
          s(a[0][3], e);
        }

        var n;
      }

      function u(e) {
        l("next", e);
      }

      function c(e) {
        l("throw", e);
      }

      function s(e, t) {
        e(t), a.shift(), a.length && l(a[0][0], a[0][1]);
      }
    }

    function w(r) {
      var e, o;
      return e = {}, t("next"), t("throw", function (e) {
        throw e;
      }), t("return"), e[Symbol.iterator] = function () {
        return this;
      }, e;

      function t(t, n) {
        e[t] = r[t] ? function (e) {
          return (o = !o) ? {
            value: m(r[t](e)),
            done: "return" === t
          } : n ? n(e) : e;
        } : n;
      }
    }

    function g(u) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var e,
          t = u[Symbol.asyncIterator];
      return t ? t.call(u) : (u = p(u), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
        return this;
      }, e);

      function n(l) {
        e[l] = u[l] && function (a) {
          return new Promise(function (e, t) {
            var n, r, o, i;
            a = u[l](a), n = e, r = t, o = a.done, i = a.value, Promise.resolve(i).then(function (e) {
              n({
                value: e,
                done: o
              });
            }, r);
          });
        };
      }
    }

    function _(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }

    function P(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }

    function x(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function O(e, t) {
      if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
      return t.get(e);
    }

    function S(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
      return t.set(e, n), n;
    }
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }], o.c = a, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) {
      o.d(n, r, function (e) {
        return t[e];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 0);

  function o(e) {
    if (a[e]) return a[e].exports;
    var t = a[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }

  var i, a;
});